import React from 'react';
import Span from '../Texts/Span/Span';
import Card from '../Card/Card';
import Icon from '../Icon/Icon';
import * as S from './CuitSelector.styles';

const CuitSelector = ({ cuit }) => {
  return (
    <Card spacing='6'>
      <S.CuitSelector>
        <S.IconWrapper>
          <Icon
            name='storefront_outline'
            height='24'
            width='24'
            variant='neutral'
            modifier='inverted'
          />
        </S.IconWrapper>
        <S.TextWrapper>
          <Span type='4' variant='neutral' weight='bold' modifier='strong'>
            Todos los establecimientos
          </Span>
          <Span type='4' variant='neutral' modifier='strong'>
            CUIT: {cuit}
          </Span>
        </S.TextWrapper>
      </S.CuitSelector>
    </Card>
  );
};

export default CuitSelector;
